import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../../../utils';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const Dealerships = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-gap: 16px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}
`;
